import Profile from '@/models/Profile';

const GET_CHART = 'GET_CHART';
const GET_DIPLOMA = 'GET_DIPLOMA';
const GET_CHART_REQUEST = 'GET_CHART_request';
const GET_CHART_SUCCESS = 'GET_CHART_success';
const GET_DIPLOMA_SUCCESS = 'GET_DIPLOMA_success';
const GET_CHART_ERROR = 'GET_CHART_error';

export { GET_CHART, GET_DIPLOMA };

export default {
    state: {
        user_id: null,
        chart: [],
        diploma_id: null,
        loading: false,
        chartErrors: []
    },
    mutations: {
        [GET_CHART_REQUEST]: (state) => {
            state.chart = [];
            state.loading = true;
            state.chartErrors = [];
        },
        [GET_CHART_SUCCESS]: (state, chart) => {
            state.chart = chart;
            state.loading = false;
            state.chartErrors = [];
        },
        [GET_DIPLOMA_SUCCESS]: (state, chart) => {
            state.diploma = chart;
            state.loading = false;
            state.chartErrors = [];
        },
        [GET_CHART_ERROR]: (state, { errors }) => {
            state.chart = [];
            state.loading = false;
            state.chartErrors = errors;
        },
    },
    actions: {
        [GET_CHART]: ({ commit, state }, { user_id = state.user_id, diploma_id = state.diploma_id }) => {
            commit(GET_CHART_REQUEST);
            return new Promise((resolve, reject) => {
                Profile.chart(user_id, diploma_id)
                    .then((data) => {
                        const chart = data;
                        commit(GET_CHART_SUCCESS, data);
                        resolve(data);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_CHART_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
        [GET_DIPLOMA]: ({ commit, state }, { user_id = state.user_id, diploma_id = state.diploma_id }) => {
            return new Promise((resolve, reject) => {
                Profile.diploma(user_id, diploma_id)
                    .then((data) => {
                        const chart = data;
                        commit(GET_CHART_SUCCESS, data);
                        resolve(data);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_CHART_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/chart.js